import React, { useContext, useState } from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  IconButton,
  Modal,
  TextField,
  useTheme
} from '@mui/material';
import Button from '@mui/material/Button';
import { Close as CloseIcon } from '@mui/icons-material';
import { I_Installation } from 'src/interfaces/InstallationTypes';
import { TokenContext } from 'src/contexts/tokenContext';
import { InstallationsContext } from 'src/contexts/InstallationsContextProvider';
import { FormattedMessage } from 'react-intl';

interface installationFormProps {
  cancel: () => void;
  submit: () => void;
  parentid: number;
  productToInsert: number;
}

function installationForm(props: installationFormProps) {
  const theme = useTheme();
  const [open, setOpen] = useState(true);

  const [formValues, setFormValues] = useState<Partial<I_Installation>>({
    installationName: '',
    name: '',
    region: '',
    location: '',
    country: '',
    vpnIp: '',
    orderNumbers: ''
  });
  const requiredFields = [
    'installationName',
    'name',
    'region',
    'location',
    'country',
    'vpnIp'
  ];
  const tokencontext = useContext(TokenContext);
  const { removeToken } = tokencontext;

  const installationContext = useContext(InstallationsContext);
  const { createInstallation, loading, setLoading, error, setError } =
    installationContext;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues({
      ...formValues,
      [name]: value
    });
  };
  const handleSubmit = async (e) => {
    setLoading(true);
    formValues.parentId = props.parentid;
    formValues.product = props.productToInsert;
    const responseData = await createInstallation(formValues);
    console.log('awaited');
    props.submit();
  };
  const handleCancelSubmit = (e) => {
    props.cancel();
  };

  const areRequiredFieldsFilled = () => {
    for (const field of requiredFields) {
      if (!formValues[field]) {
        return false;
      }
    }
    return true;
  };

  const isMobile = window.innerWidth <= 1490;

  return (
    <>
      <Modal
        open={open}
        onClose={() => {}}
        aria-labelledby="error-modal"
        aria-describedby="error-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: isMobile ? '50%' : '40%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90vw', sm: 500 },
            bgcolor: 'background.paper',
            borderRadius: 4,
            boxShadow: 24,
            p: 4
          }}
        >
          <Box
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center', // Center items horizontally
              '& .MuiTextField-root': {
                m: 1,
                width: { xs: '100%', md: 390 }
              }
            }}
            noValidate
            autoComplete="off"
          >
            <div>
              <TextField
                label={
                  <FormattedMessage
                    id="installationName"
                    defaultMessage="Installation Name"
                  />
                }
                name="installationName"
                value={formValues.installationName}
                onChange={handleChange}
                required
                error={formValues.installationName === ''}
              />
            </div>
            <div>
              <TextField
                label={
                  <FormattedMessage
                    id="customerName"
                    defaultMessage="Customer Name"
                  />
                }
                name="name"
                value={formValues.name}
                onChange={handleChange}
                required
                error={formValues.name === ''}
              />
            </div>

            <div>
              <TextField
                label={<FormattedMessage id="region" defaultMessage="Region" />}
                name="region"
                value={formValues.region}
                onChange={handleChange}
                required
                error={formValues.region === ''}
              />
            </div>
            <div>
              <TextField
                label={
                  <FormattedMessage id="location" defaultMessage="Location" />
                }
                name="location"
                value={formValues.location}
                onChange={handleChange}
                required
                error={formValues.location === ''}
              />
            </div>

            <div>
              <TextField
                label={
                  <FormattedMessage id="country" defaultMessage="Country" />
                }
                name="country"
                value={formValues.country}
                onChange={handleChange}
                required
                error={formValues.country === ''}
              />
            </div>

            <div>
              <TextField
                label={<FormattedMessage id="VpnIp" defaultMessage="VpnIp" />}
                name="vpnIp"
                value={formValues.vpnIp}
                onChange={handleChange}
                required
                error={formValues.vpnIp === ''}
              />
            </div>

            <div>
              <TextField
                label={
                  <FormattedMessage
                    id="orderNumbers"
                    defaultMessage="Order Numbers"
                  />
                }
                name="orderNumbers"
                value={formValues.orderNumbers}
                onChange={handleChange}
              />
            </div>
          </Box>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 10
            }}
          >
            <Button
              variant="contained"
              onClick={handleSubmit}
              sx={{
                marginLeft: '20px'
              }}
              disabled={!areRequiredFieldsFilled()}
            >
              <FormattedMessage id="submit" defaultMessage="Submit" />
            </Button>

            <Button
              variant="contained"
              onClick={handleCancelSubmit}
              sx={{
                marginLeft: '10px'
              }}
            >
              <FormattedMessage id="cancel" defaultMessage="Cancel" />
            </Button>

            {loading && (
              <CircularProgress
                sx={{
                  color: theme.palette.primary.main,
                  marginLeft: '20px'
                }}
              />
            )}

            {error && (
              <Alert
                severity="error"
                sx={{
                  ml: 1,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <FormattedMessage
                  id="errorOccured"
                  defaultMessage="An error has occured"
                />
                <IconButton
                  color="inherit"
                  size="small"
                  onClick={() => setError(false)}
                  sx={{ marginLeft: '4px' }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Alert>
            )}
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default installationForm;
